import React from 'react'
import LoaderButton from '../../components/LoaderButton'
import FormViewer from '../../components/FormViewer'
import { translate } from '../../utils/useful'
import { siteConfig, siteTheme } from '../../variables/config'

class LoginFirstStepLoginFirstStep extends React.Component {
    state = {
        key: '',
        selectedCountry: {},
        data: {},
        isLoading: false,
        formHeaders: [
            { key: 'username', type: 'TextInput', information: { label: '{{lang}}username', icon: '/images/man.svg', placeholder: '{{lang}}username', required: true } },
            // { key: 'family', type: 'TextInput', information: { label: '{{lang}}family', icon: 'https://image.flaticon.com/icons/svg/13/13305.svg', placeholder: '{{lang}}insertFamily', required: true } },
            { key: 'password', type: 'PasswordInput', information: { label: '{{lang}}password', icon: '/images/key.svg', placeholder: '{{lang}}password', required: true } }
        ]
    }

    componentDidMount() {
        // let formHeaders = [{ key: 'userIndicator', type: 'PhoneInput', information: { label: '{{lang}}phonenumber', placeholder: '{{lang}}phonenumber', required: true } }]
        // if (this.props.initData.indicatorType && this.props.initData.indicatorType === 'email') {
        //     formHeaders = [{ key: 'userIndicator', type: 'EmailInput', information: { label: '{{lang}}phonenumber', placeholder: '{{lang}}phonenumber', required: true } }]
        // }
        document.addEventListener("keydown", this._handleKeyDown);
        // this.setState({ formHeaders })
    }


    componentWillUnmount = () => {
        document.removeEventListener("keydown", this._handleKeyDown);
    }

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.postUserIndicator()
        }
    }




    postUserIndicator = () => {
        let data = this.form.getForm()
        if (data) {
            this.setState({ isLoading: true, errors: {} })
            this.props.setData(data, () => {
                this.props.postUserIndicator((result, err) => {
                    if (err) { this.setState({isLoading: false, errors: err }) }
                    this.setState({ isLoading: false })
                })
            })
        }
    }


    render() {
        return (
            <div className="flexcc flex-column">

                <img className=" mb-2" src={siteTheme.logo} width={'60px'} />
                {/* <h1 className="text-ultra-big white">{siteConfig.siteName}</h1> */}

                {/* {this.props.settings.mode === 'forgotPassword' ? (
                    <h2 className="mt-4 " style={{ fontSize: 27 }}>Forgot Password</h2>
                ) : (
                    <div className='w-100 text-center'>
                        <h2 className="mt-3 mb-0" style={{ fontSize: 27, whiteSpace: 'nowrap', color: '#005249' }}>{siteConfig.siteName}</h2>
                    </div>
                )} */}
                        <h2 className="mt-1 mb-0" style={{ fontSize: 24, whiteSpace: 'nowrap', color: '#202020' ,textTransform:'uppercase'}}>{siteConfig.siteName}</h2>
                <h2 className="mt-0 mb-4" style={{ fontSize: 18, whiteSpace: 'nowrap', color: '#000', letterSpacing: 2,textTransform:'uppercase', opacity: 0.4 }}>Admin Panel</h2>

                <div className="w-100" style={{ maxWidth: 400 }}>

                    <FormViewer ref={el => this.form = el} headers={this.state.formHeaders} initData={this.props.initData} errors={this.state.errors} inputClass={'modern-input'} />

                    <div className="text-center">
                        <LoaderButton
                            onClick={this.postUserIndicator}
                            isLoading={this.state.isLoading}
                            text={translate('send')}
                            type={"Oval"}
                            className="mt-4 mb-4"
                            buttonStyle={{ outline: 'none', backgroundColor: 'rgb(217, 0, 0)', cursor: 'pointer', padding: '10px 50px', borderRadius: 40, fontSize: 15, fontWeight: 'bold', color: '#fff', border: 'none' }}
                            width={40}
                            height={40}
                            color={'#202020'}
                        />
                        {/* <p style={{ fontSize: 15, margin: '10px 20px 20px' }}>{translate("insert-phone-desc")}</p> */}
                        <p style={{ fontSize: 13, opacity: 0.5, marginTop: 10 }}>{translate('cookie-warning')}</p>
                    </div>
                </div>
            </div>
        )
    }
}

export default LoginFirstStepLoginFirstStep